/**
 * Auth directives — v-can and v-role
 *
 * Backed by the Vuex `user` module getters `can` and `hasRole`.
 * Both getters are curried: state => (value) => boolean.
 *
 * Usage in templates:
 *   <button v-can="'edit-tenders'">Edit</button>
 *   <button v-can="['edit-tenders', 'delete-tenders']">Edit or Delete</button>
 *   <div v-role="'admin'">Admin panel</div>
 *   <div v-role="['admin', 'manager']">Admin or Manager</div>
 */

import store from '@/store'

export const canDirective = {
  /**
   * Called once when the element is inserted.
   * Removes the element from the DOM if the user lacks the permission.
   * @param {HTMLElement} el
   * @param {import('vue').DirectiveBinding} binding - binding.value is string | string[]
   */
  inserted(el, binding) {
    const can = store.getters['user/can']
    if (!can(binding.value)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  },
}

export const roleDirective = {
  /**
   * Removes the element from the DOM if the user lacks the role.
   * @param {HTMLElement} el
   * @param {import('vue').DirectiveBinding} binding - binding.value is string | string[]
   */
  inserted(el, binding) {
    const hasRole = store.getters['user/hasRole']
    if (!hasRole(binding.value)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  },
}
